export default ({
  label = '',
  value: rawValue,
  isPercent
}) => {
  let value = rawValue;
  if (isPercent) {
    value = (rawValue === null || rawValue === undefined || rawValue === '') ? '-' : `${Math.round(rawValue)}%`;
  } else {
    value = rawValue || '-';
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div style={{ fontWeight: 'bold', color: '#565656', fontSize: '20px' }}>{value}</div>
      <div style={{ fontWeight: 'bold', marginLeft: '5px', color: '#565656', fontSize: '17px' }}>{label}</div>
    </div>
  )
}